import { render, staticRenderFns } from "./ReversalBody.vue?vue&type=template&id=5fc7cced&scoped=true&"
import script from "./ReversalBody.vue?vue&type=script&lang=js&"
export * from "./ReversalBody.vue?vue&type=script&lang=js&"
import style0 from "./ReversalBody.vue?vue&type=style&index=0&id=5fc7cced&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc7cced",
  null
  
)

export default component.exports